// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-mobile-menu__wrapper .header-mobile-menu__icon-wrapper[data-v-6eaa7d5c]{padding:8px;width:40px;height:40px}", ""]);
// Exports
module.exports = exports;
